import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.jsx'
import './index.css'
import { initSentry, createRootErrorOptions } from './lib/sentry.js'

// Fire-and-forget - initSentry resolves with the Sentry instance OR null
// when VITE_SENTRY_DSN is unset / @sentry/react isn't installed. Either
// way the marketing site boots immediately; no top-level await.
initSentry()

createRoot(document.getElementById('root'), createRootErrorOptions()).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
)
